<template>
  <div class="printPage">
    <div class="marSet">
      <a class="btn" @click="clkDC">Export</a>
      <h2>Quote</h2>
    </div>
    <table id="table-content" bordercolor="#e6e6e6" border="1" cellspacing="0" cellpadding="0" width="100%" class="invoiceTable" style="page-break-after:always;width:210mm">
      <tr>
        <td width="64%" align="left">
          <p>
            <img src="../../../assets/img/logoBlue.png" width="150" />
          </p>
          <p class="marT10">Add.:&nbsp;<em class="font12">Floor 27,Block A,World Trade Plaza,Fuhong Rd,Futian District,Shenzhen,China</em></p>
          <p>EMAIL:&nbsp;Support.by56.com </p>
        </td>
        <td align="right">
          <p><span class="setTitle">Inquiry name:&nbsp;</span><span class="setText">{{InqDetails.Order.InquiryName}}</span></p>
          <p><span class="setTitle">Inquiry no.:&nbsp;</span><span class="setText">{{InqDetails.Order.InWaybillNO}}</span></p>
          <p><span class="setTitle">Quotation no.:&nbsp;</span><span class="setText">{{airInListData.Price.BJWaybillNO}}</span></p>
          <p><span class="setTitle">Inquiry date:&nbsp;</span><span class="setText">{{InqDetails.Order.CreateTime | dateFmt('MMM DD, YYYY')}}</span></p>
          <p><span class="setTitle">Valid until:&nbsp;</span><span class="setText">{{airInListData.Price.PriceValidDate | dateFmt('MMM DD, YYYY')}}</span></p>
        </td>
      </tr>
      <tr>
        <td colspan="2" style="padding:0px;">
          <table bordercolor="#e6e6e6" border="1" cellspacing="0" cellpadding="0" width="100%" class="invoiceTable" style="border-left:0px;border-right:0px;">
            <tr>
              <td width="45%" class="borTop borR veTop" style="padding:0px;">
                <div style="padding:5px 10px;">
                  <p>Quote Prepared For:&nbsp;{{InqDetails.Order.CustomerName}}</p>
                  <p>Mode:&nbsp;{{InqDetails.Order.InquiryType==1 ? 'Air Freight': InqDetails.Order.InquiryType==2 ?'LCL':''}}</p>
                  <p>Service type:&nbsp;{{transServType(InqDetails.Order.OrderServiceType)}}</p>
                  <!-- <p><span class="l">Mode:&nbsp;{{InqDetails.Order.InquiryType==1 ? 'Air Freight': InqDetails.Order.InquiryType==2 ?'LCL':''}}</span>
                            <span class="marL10 r">Service type:&nbsp;{{transServType(InqDetails.Order.OrderServiceType)}}</span></p> -->
                  <p class="cl">Cargo ready:&nbsp;{{InqDetails.Order.PlanDeliveryTime| dateFmt('MMM DD, YYYY')}}</p>
                  <p>Estimated arrival date:&nbsp;{{airInListData.Price.PlanArrDate| dateFmt('MMM DD, YYYY')}}</p>
                </div>
                <div class="borTop" style="padding:5px 10px;">
                  <h3 style="margin:5px 0;">Cargo Totals</h3>
                  <p>Total weight:&nbsp;{{InqDetails.Order.Weight}}KG</p>
                  <p>Total volume:&nbsp;{{InqDetails.Order.VolumeCBM}}CBM</p>
                  <p>Total units:&nbsp;{{InqDetails.Order.PackageQuanlity}}<em v-if="InqDetails.Order.PackageQuanlity==1">Unit</em><em v-if="InqDetails.Order.PackageQuanlity>1">Units</em></p>
                </div>
                <div class="titleBg borTop" style="overflow:hidden;padding:6px 10px">
                  <b class="l" style="font-size:14px;">Route</b>
                  <span class="r" v-if="InqDetails.Order.OrderServiceType!=3">Transit time Estimate:&nbsp;{{airInListData.Price.TotalWorkDay}}days</span>
                  <!-- <span class="r" v-if="InqDetails.Order.OrderServiceType==1">起运机场到目的地估计：{{airInListData.Price.TotalMaxWorkDay-2}}天</span>
                            <span class="r" v-if="InqDetails.Order.OrderServiceType==4">起运机场到目的地估计：{{airInListData.Price.TotalMaxWorkDay}}天</span> -->
                </div>
                <div style="padding:5px 10px;">
                  <p class="l" v-if="InqDetails.Order.OrderServiceType==1 || InqDetails.Order.OrderServiceType==2">Origin:&nbsp;<br /> 2-3days</p>
                  <!-- <p class="l" style="margin:0 20px">起运机场到目的机场：<br /> {{airInListData.Price.TotalMaxWorkDay - airInListData.Price.ThWorkDayValue - 4 }}天 </p> -->

                  <p class="l" style="margin:0 20px">Port to Port:&nbsp;<br />
                    <!-- 门到门 时效 -->
                    <span v-if="InqDetails.Order.OrderServiceType==1 && airInListData.Price.TotalMinWorkDay - 2 - 1 > 0">{{ airInListData.Price.TotalMinWorkDay - 2 - 1 }}days</span>
                    <span v-if="InqDetails.Order.OrderServiceType==1 && airInListData.Price.TotalMinWorkDay - 2 - 1 <= 0"> 1days</span>
                    <!-- 门到机场 时效 -->
                    <span v-if="InqDetails.Order.OrderServiceType==2 && airInListData.Price.TotalMinWorkDay -2 > 0">{{airInListData.Price.TotalMinWorkDay -2}}days</span>
                    <span v-if="InqDetails.Order.OrderServiceType==2 && airInListData.Price.TotalMinWorkDay -2 <= 0">1days</span>
                    <!-- 机场到机场 时效 -->
                    <span v-if="InqDetails.Order.OrderServiceType==3">{{airInListData.Price.TotalWorkDay}}days</span>
                    <!-- 机场到门 时效 -->
                    <span v-if="InqDetails.Order.OrderServiceType==4 && airInListData.Price.TotalMinWorkDay - 1 > 0">{{airInListData.Price.TotalMinWorkDay - 1}}days</span>
                    <span v-if="InqDetails.Order.OrderServiceType==4 && airInListData.Price.TotalMinWorkDay - 1 <= 0">1days</span>
                  </p>
                  <p class="r" v-if="InqDetails.Order.OrderServiceType==1 || InqDetails.Order.OrderServiceType==4">Destination:&nbsp;<br /> 1-4days</p>
                </div>
                <div class="cl"></div>
                <div class="borTop" style="padding:5px 10px;">
                  <p v-if="InqDetails.Order.OrderServiceType==1 || InqDetails.Order.OrderServiceType==2"><b>Origin City</b><span class="marL10 font12">{{InqDetails.Order.StartCityNameEn}},{{InqDetails.Order.StartProNameEn}},{{InqDetails.Order.StartCountryNameEn}}</span></p>
                  <p><b>Departure Airport</b><span class="marL10 font12">{{airInListData.Price.DepartureCode}}，{{airInListData.Price.DepartureNameEn}}</span></p>
                  <p v-if="TransferAirportInfo && TransferAirportInfo.length > 0"><b>Transit Airport</b><span class="marL10 font12" v-for="(info,index) in TransferAirportInfo" :key="index">{{info.AirportCode}}，{{info.AirportNameEn}}</span>
                  </p>
                  <p><b>Arrival Airport</b><span class="marL10 font12">{{airInListData.Price.DestinationCode}}，{{airInListData.Price.DestinationNameEn}}</span></p>
                  <p v-if="InqDetails.Order.OrderServiceType==1 || InqDetails.Order.OrderServiceType==4"><b>Destination City</b><span class="marL10 font12">{{InqDetails.Order.DestCityNameEn}},<span v-if="InqDetails.Order.DestProNameEn">{{InqDetails.Order.DestProNameEn}},</span>{{InqDetails.Order.DestCountryNameEn}}</span></p>
                </div>
              </td>
              <td class="borTop veTop" style="padding:0;">
                <h3 class="titleBg">Rate information</h3>
                <table border="0" cellspacing="0" cellpadding="0" width="100%" class="Table2">
                  <tr>
                    <td align="left" class="borBot" width="30%">
                      <span v-if="InqDetails.Order.OrderServiceType==1 || InqDetails.Order.OrderServiceType==2">{{InqDetails.Order.StartCityNameEn}}</span>
                      <span v-else>{{airInListData.Price.DepartureCode}}</span>
                      <span>&nbsp;>&nbsp;</span>
                      <span>{{airInListData.Price.DestinationCode}}</span>
                    </td>
                    <td align="right" class="borBot" width="22%">Unit rate</td>
                    <td align="left" class="borBot" width="23%">QTY</td>
                    <td align="right" class="borBot">Amount</td>
                  </tr>
                  <tr>
                    <td align="left">Air Freight Cost</td>
                    <td align="right">US&nbsp;${{Number(airInListData.Price.CusAirAmount / airInListData.Price.CusChargeWeight).toFixed(2)}} </td>
                    <td align="left">x {{InterceptUnit(airInListData.Price.CusChargeWeight,3)}}KG</td>
                    <td align="right"><span class="cloRed">US&nbsp;${{Number(airInListData.Price.CusAirAmount).toFixed(2)}}</span></td>
                  </tr>
                  <tr v-show="airInListData.Price.ThAmount > 0">
                    <td align="left">Pickup Charge</td>
                    <td align="right">US&nbsp;${{Number(airInListData.Price.ThAmount / airInListData.Price.ThChargeWeight).toFixed(2)}} </td>
                    <td align="left">x {{InterceptUnit(airInListData.Price.ThChargeWeight,3)}}KG</td>
                    <td align="right"><span class="cloRed">US&nbsp;${{Number(airInListData.Price.ThAmount).toFixed(2)}}</span></td>
                  </tr>
                  <tr v-for="(info,index) in airInListData.Bill" :key="'a'+index" v-if="info.BillType==2">
                    <td align="left" style="padding:2px 10px;">{{info.FeeNameEn}}</td>
                    <td align="right" style="padding:2px 10px;">US&nbsp;$<span>{{Number(info.ForAmount / info.Quanlity).toFixed(2)}}</span> </td>
                    <td align="left" style="padding:2px 10px;">x <span v-if="info.Unit==3">{{Number(info.Quanlity).toFixed(3)}}</span><span v-if="info.Unit==1">{{Number(info.Quanlity).toFixed(4)}}</span> <span v-if="info.Unit!=3 && info.Unit!=1">{{info.Quanlity}}</span> {{JuderUnit(info.Unit)}}</td>
                    <td align="right" style="padding:2px 10px;">
                      <p class="colRed">US&nbsp;${{Number(info.ForAmount).toFixed(2)}}</p>
                    </td>
                  </tr>
                  <tr>
                    <td align="left" colspan="2"><b>Subtotal</b></td>
                    <td align="right" colspan="2"><b class="colRed">US&nbsp;${{Number(totolFee1).toFixed(2)}}</b></td>
                  </tr>

                  <tbody v-if="InqDetails.Order.OrderServiceType==1 || InqDetails.Order.OrderServiceType==4">
                    <tr>
                      <td align="left" class="borBot borTop">{{airInListData.Price.DestinationCode}}&nbsp;>&nbsp;{{InqDetails.Order.DestCityNameEn}}</td>
                      <td align="right" class="borBot borTop">Unit rate</td>
                      <td align="left" class="borBot borTop">QTY</td>
                      <td align="right" class="borBot borTop">Amount</td>
                    </tr>
                    <tr class="lineBor" v-show="airInListData.Price.DeliverAmount > 0">
                      <td align="left">Delivery Charge</td>
                      <td align="right">US&nbsp;${{Number(airInListData.Price.DeliverAmount / airInListData.Price.DestChargeWeight).toFixed(2)}} </td>
                      <td align="left">x {{InterceptUnit(airInListData.Price.DestChargeWeight,3)}}KG</td>
                      <td align="right">
                        <p class="colRed">US&nbsp;${{Number(airInListData.Price.DeliverAmount).toFixed(2)}}</p>
                      </td>
                    </tr>
                    <tr class="lineBor" v-for="(info,index) in airInListData.Bill" :key="'b'+index" v-show="info.BillType==3">
                      <td align="left" style="padding:2px 10px;">{{info.FeeNameEn}}</td>
                      <td align="right" style="padding:2px 10px;">US&nbsp;$<span>{{Number(info.ForAmount / info.Quanlity).toFixed(2)}}</span> </td>
                      <td align="left" style="padding:2px 10px;">x <span v-if="info.Unit==3">{{InterceptUnit(info.Quanlity,3)}}</span><span v-if="info.Unit==1">{{InterceptUnit(info.Quanlity,4)}}</span> <span v-if="info.Unit!=3 && info.Unit!=1">{{info.Quanlity}}</span>{{JuderUnit(info.Unit)}}</td>
                      <td align="right" style="padding:2px 10px;">
                        <p class="colRed">US&nbsp;${{Number(info.ForAmount).toFixed(2)}}</p>
                      </td>
                    </tr>
                    <tr>
                      <td align="left"><b>Subtotal</b></td>
                      <td align="right" colspan="3"><b class="colRed">US&nbsp;$&nbsp;{{Number(totolFee2).toFixed(2)}}</b></td>
                    </tr>
                    <tr class="lineBor" v-for="(info,index) in airInListData.Bill" :key="'c'+index" v-if="info.BillType==4">
                      <td align="left"><b>{{info.FeeNameEn}}</b></td>
                      <!-- <td align="right">US&nbsp;$<span>{{Number(info.ForAmount / info.Quanlity).toFixed(2)}}</span> </td>
                                <td align="left">x <span v-if="info.Unit==3">{{InterceptUnit(info.Quanlity,3)}}</span><span v-if="info.Unit==1">{{InterceptUnit(info.Quanlity,4)}}</span> <span v-if="info.Unit!=3 && info.Unit!=1">{{info.Quanlity}}</span>{{JuderUnit(info.Unit)}}</td> -->
                      <td align="right" colspan="3"><b class="colRed">US&nbsp;${{Number(info.ForAmount).toFixed(2)}}</b></td>
                    </tr>
                  </tbody>
                  <tr>
                    <td align="left" bgColor="#FAFDFF" colspan="2"><b>Total</b></td>
                    <td align="right" bgColor="#FAFDFF" colspan="2"><b class="colRed">US&nbsp;${{Number(airInListData.Price.TotalAmount).toFixed(2)}}</b></td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <!-- <tr v-if="airInListData.Price.SpecialConditions">
            <td colspan="2" class="borTop setTextBot">
              <p>特价条件： </p>
              <p>{{airInListData.Price.SpecialConditions}}</p>
            </td>
          </tr> -->
    </table>
  </div>
</template>
<script type="text/ecmascript-6">
import { getCookie } from '../../../ask/cookiejs'
import { post, fetch, Del, put } from '../../../ask/axios'
export default {

  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      InqDetails: {
        Order: {
          InquiryName: '', InWaybillNO: '', CreateTime: '', InquiryType: null, OrderServiceType: null, PlanDeliveryTime: '', Weight: '', VolumeCBM: '', PackageQuanlity: '',
          StartProNameCn: '', StartCityNameCn: '', StartCityAreaNameCn: '', DestProNameEn: '', DestCountryNameEn: '', DestCityNameEn: '', CustomerName: '',//客户名称
        }
      },
      airInListData: {
        Price: {
          BJWaybillNO: '', PriceValidDate: '', PlanArrDate: '', TotalWorkDay: '', ThWorkDay: '', TotalMaxWorkDay: '', DepartureCode: '',
          DepartureName: '', DestinationCode: '', DestinationName: '', CusAirAmount: '', CusChargeWeight: '', ThAmount: '', ThChargeWeight: '', SpecialConditions: '', TotalAmount: null,
        },
        Bill: [],
      },

      TransferAirportInfo: [],

    }
  },
  created() {
    this.detailsAPI();
    this.airDelAPI();
  },
  watch: {

  },
  computed: {//计算属性
    //费用合计
    totolFee1() {
      let num = 0
      if (this.airInListData.Bill.length > 0) {
        this.airInListData.Bill.forEach(info => {
          if (info.BillType == 2) {
            num += Number(info.ForAmount)
          }
        })
      }

      return num + Number(this.airInListData.Price.CusAirAmount) + Number(this.airInListData.Price.ThAmount)
    },
    //费用合计
    totolFee2() {
      let num = 0
      if (this.airInListData.Bill.length > 0) {
        this.airInListData.Bill.forEach(info => {
          if (info.BillType == 3) {
            num += Number(info.ForAmount)
          }
        })
      }
      return num + Number(this.airInListData.Price.DeliverAmount)
    }
  },
  methods: {
    //询盘详情接口
    detailsAPI() {
      let that = this;
      this.api.param = {
        InWaybillNO: that.$route.query.billNO
      };
      this.api.url = this.$api04 + "/Air/api/AirInquiryOrder/AirInquiryDetail"
      post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK) {
          that.InqDetails = res.Results
        }
      })
    },

    airDelAPI() {
      let that = this;
      this.api.param = {
        BJWaybillNO: that.$route.query.BJbillNO
      };
      this.api.url = this.$api04 + "/Air/api/AirInOrderSupPriceInfo/Detail"
      post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK) {
          that.airInListData = res.Results
          that.TransferAirportInfo = JSON.parse(that.airInListData.Price.TransferAirportInfo)
        }
      })
    },
    //订单服务类型转换 
    transServType(val) {
      // 订单服务类型。1：门到门，2：门到机场，3：机场到机场，4：机场到门
      if (val == 1) return 'Door to Door'
      if (val == 2) return 'Door to Terminal'
      if (val == 3) return 'Terminal to Terminal'
      if (val == 4) return 'Terminal to Door'
    },

    //费用列表单位转换
    JuderUnit(val) {
      if (val == 0) return 'Bill'
      if (val == 1) return 'CBM'
      if (val == 2) return 'Pcs'
      if (val == 3) return 'KG'
      if (val == 4) return 'page'
      if (val == 5) return 'Bill'
      if (val == 6) return 'Day'
      if (val == 7) return 'Time'
      if (val == 8) return 'Unit'
    },

    //导出
    clkDC() {
      this.getPdf('table-content', '报价单.pdf')
    },

  }

}

</script>
<style type="text/css" rel="stylesheet" scoped="scoped">
/* @import "../../../../static/css/userCenterEdit.css"; */
.invoiceTable {
  width: 100%;
}
.invoiceTable tr th {
  padding: 5px 10px;
  font-size: 12px;
  color: #333;
}
.invoiceTable tr td {
  font-size: 13px;
  color: #333;
  padding: 5px 10px;
  word-break: break-all;
  border: none;
  color: #000;
}
.invoiceTable tr td p {
  line-height: 24px;
}
.invoiceTable tr td.borTop {
  border-top: 1px solid #e6e6e6;
}
.invoiceTable tr td.borR {
  border-right: 1px solid #e6e6e6;
}
.invoiceTable tr td.borBot {
  border-bottom: 1px solid #e6e6e6;
}
.invoiceTable tr td.setTextBot p {
  font-size: 12px;
  line-height: 20px;
  color: #666;
}

.Table2 {
  width: 100%;
}
.Table2 tr td {
  font-size: 12px;
  color: #333;
  padding: 5px 10px;
  word-break: break-all;
  border: none;
  color: #444;
}

.printPage {
  padding: 5px 20px 20px;
  background: white;
  width: 210mm;
}
.printPage h2 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 26px;
}
.marSet {
  margin: 30px 0 0 0;
}
.printPage .btn {
  background: #004fb1;
  padding: 5px 30px;
  color: #fff;
  border-radius: 30px;
  font-size: 14px;
}
.setTitle {
  width: 40%;
  float: left;
  text-align: right;
}
.setText {
  width: 60%;
  float: right;
}
.printPage .titleBg {
  background: #fafdff;
  padding: 5px;
  border-bottom: 1px solid #e6e6e6;
}

.borTop {
  border-top: 1px solid #e6e6e6;
}
.borR {
  border-right: 1px solid #e6e6e6;
}
.borBot {
  border-bottom: 1px solid #e6e6e6;
}

.marT10 {
  margin-top: 10px;
}
.marL10 {
  margin-left: 10px;
}
.marL20 {
  margin-left: 20px;
}
.l {
  float: left;
}
.r {
  float: right;
}
.cl {
  clear: both;
}
.veTop {
  vertical-align: top;
}
.cloRed {
  color: red;
}

@page {
  margin: 0;
} /* 去掉页眉页脚 */
@media print {
  .btnBox {
    visibility: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/myInquiry/airInPrint.vue